module.exports = __webpack_public_path__ + "img/icon-phone-color.973a141ca51cb42971c1c964e970c701.svg";